import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import '../../../components_style/doctorComponents/FormsStyle.css'
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import * as Yup from "yup";
import SelfPatientDetails from "../../../components/Patient_SelfOnboard/SelfPatientDetails";
import SelfLifestyle from "../../../components/Patient_SelfOnboard/SelfLifestyle";
import SelfContactDetails from "../../../components/Patient_SelfOnboard/SelfContactDetails";
import Self_Physiological_biometrics from "../../../components/Patient_SelfOnboard/Self_Physiological_biometrics";


const validationSchema = Yup.object().shape({
    ID_passport:Yup.string().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only').test('len', 'Must be exactly 9 characters', val => val.length === 9),
    House_number:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Phone_num2:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Systolic_blood_press_mmHg:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Diastolic_blood_press_mmHg:Yup.string().matches(/^\d*$/, 'The field should have digits only').nullable(),
    Email:Yup.string().matches( /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,'Mail is invalid').nullable(),

/*
    receiving_asaya_system_assisted:Yup.string().nullable().required('This field is mandatory'),
*/
    First_name:Yup.string().required('This field is mandatory'),
    Last_name:Yup.string().required('This field is mandatory'),
/*
    Gender:Yup.string().nullable().required('This field is mandatory'),
*/
/*
    Insuring_factor:Yup.string().nullable().required('This field is mandatory'),
*/
    Phone_num1:Yup.string().nullable().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only'),
/*    Driving:Yup.string().nullable().required('This field is mandatory'),
    Pregnant: Yup.string().when("Gender", {
        is: value => {
            return value === "Female"
        },
        then: Yup.string().required('This field is mandatory'),
        otherwise: Yup.string().nullable()
    }),
    Breast_feeding: Yup.string().when("Gender", {
        is: value => {
            return value === "Female"
        },
        then: Yup.string().nullable().required('This field is mandatory'),
        otherwise: Yup.string().nullable()
    }),
    Commercial_license: Yup.string().when("Driving", {
        is: value => {
            return value === "Yes"
        },
        then: Yup.string().nullable().required('This field is mandatory'),
        otherwise: Yup.string().nullable()
    }),*/
})

class SelfPersonalDetailsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
            errors:this.props.errors
        };
    }

    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }

    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }



/*
    componentWillMount() {
        this.props.initValidation(validationSchema)
    }
*/
    onclickSetProfilePic = (value) => {
        this.props.onclickSetProfilePic(value)
    }


    render() {
        let {t} = this.props

        return (
            <div className={'patientForm-box-container'}>
                    <FormElementContainer title={t('patient_self_boarding.personal_details')}
                                              Component={SelfPatientDetails}
                                              rest={{
                                                  onValueChange:(name,value) => this.onValueChange(name,value) ,
                                                  entry:this.props.entry,
                                                  onclickSetProfilePic:(value) => this.onclickSetProfilePic(value) ,
                                                  profilePic:this.props.profilePic,
                                                  errors:this.props.errors,
                                                  t:(e) => this.props.t(e),
                                                  onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value)

                                              }}/>

                    <FormElementContainer title={t('patient_self_boarding.ContactDetails')}
                                          Component={SelfContactDetails}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                              entry:this.props.entry,
                                              cityList:this.props.cityList,
                                              israelCities:this.props.israelCities,
                                              t:(e) => this.props.t(e),
                                              errors:this.props.errors,
                                          }}/>


                    <FormElementContainer title={t('patient_self_boarding.Lifestyle')}
                                          Component={SelfLifestyle}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                              entry:this.props.entry,
                                              errors:this.props.errors,
                                              t:(e) => this.props.t(e),
                                          }}/>

                   <FormElementContainer title={t('patient_self_boarding.Physiological_Biometrics')}
                                         Component={Self_Physiological_biometrics}
                                         rest={{
                                             onValueChange:(name,value) => this.onValueChange(name,value) ,
                                             entry:this.props.entry,
                                             t:(e) => this.props.t(e),
                                             errors:this.props.errors
                                         }}/>


                    <div className={'blankSpace'}/>
{/*
                </div>
*/}
            </div>
        );
    }
}



const SelfPersonalDetailsTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(SelfPersonalDetailsTabComposed);

export default SelfPersonalDetailsTab;
